module.exports = __webpack_public_path__ + "img/温度在线监测.66dfb4dc.png";